export enum CatalogSortingEnum {
  ALPHA_ASC = 'ALPHA_ASC',
  ALPHA_DESC = 'ALPHA_DESC',
  FEATURED = 'FEATURED',
  NONE = 'NONE',
}
